import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'
import { isEmpty, capitalize, uniq } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { GET_ITEMS_AUTOCOMPLETE } from 'resolvers/items'
import { normalize } from 'utils/string'

const messages = defineMessages({
  newLabel: {
    id: 'units.suggestion.newLabel',
    defaultMessage: '(New)'
  }
})

export const InputUnitsSuggestion = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { data, loading, refetch } = useQuery(GET_ITEMS_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      companyId: props.companyId
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  const filteredExistingItems =
    (data &&
      data.itemsAutocomplete &&
      uniq(
        data.itemsAutocomplete
          .filter((item: TSFixMe): TSFixMe => {
            return item.units && normalize(item.units).includes(normalize(pattern))
          })
          .map(({ units }: TSFixMe): TSFixMe => units)
          .sort((a: TSFixMe, b: TSFixMe): TSFixMe => a.localeCompare(b))
      )) ||
    []

  let shownItems = [...filteredExistingItems]

  if (pattern && !shownItems.map(normalize).includes(normalize(pattern))) {
    shownItems = [pattern, ...shownItems]
  }

  const handleChange = (units: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(units)) {
      props.onChange(units)
    } else {
      props.onChange(inputValue)
    }
  }

  const handleBlur = (event: TSFixMe): TSFixMe => {
    if (pattern) {
      const matchedItem = filteredExistingItems.find((item: TSFixMe): TSFixMe => normalize(item) === normalize(pattern))

      if (!isEmpty(matchedItem)) {
        props.onChange(matchedItem)
      } else {
        props.onChange(capitalize(pattern))
      }
    }

    props.onBlur(event)
  }

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(units): TSFixMe => {
        if (filteredExistingItems.map(normalize).includes(normalize(units))) {
          return units
        }

        return `${units} ${intl.formatMessage(messages.newLabel)}`
      }}
      loading={loading}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}
